import { CSSProperties } from 'react';
import styles from './button.module.scss';
import React from 'react';
import IButton from '../../../models/button/IButton';
import { getHeapAttributes } from '../../../utils/heap/heap.helper';

export default function Button({
  buttonID,
  buttonURL,
  buttonNewTab,
  buttonAriaLabel,
  buttonRole,
  buttonName,
  buttonSize,
  buttonStyle,
  copyColor,
  backgroundColor,
  hoverBackgroundColor,
  activeBackgroundColor,
  outlineColor,
  buttonType,
  children,
  onClick = null,
  disabled = false,
  heapIdentifier,
  customClass,
}: IButton) {
  function clickHandler() {
    if (onClick) {
      onClick();
    }
  }

  const buttonClasses = [styles.button, styles[customClass]];

  if (buttonSize) {
    buttonClasses.push(styles[buttonSize]);
  }

  if (buttonStyle) {
    buttonClasses.push(styles[buttonStyle]);
  }

  if (buttonURL) {
    buttonClasses.push(styles['button-link']);
  }

  const buttonClassName = buttonClasses.join(' ');

  const cssVariables = {
    '--button-copy-color': copyColor,
    '--button-background-color': backgroundColor,
    '--button-hover-background-color': hoverBackgroundColor,
    '--button-active-background-color': activeBackgroundColor,
    '--button-outline-color': outlineColor,
  } as CSSProperties;

  const heapAttributes =
    heapIdentifier && getHeapAttributes(heapIdentifier, { button: buttonAriaLabel });

  if (buttonURL) {
    return (
      <a
        className={buttonClassName}
        style={cssVariables}
        aria-label={buttonAriaLabel}
        id={buttonID}
        href={buttonURL}
        target={buttonNewTab ? buttonNewTab : '_self'}
        onClick={onClick}
        role={buttonRole}
        {...heapAttributes}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      style={cssVariables}
      type={buttonType || 'button'}
      className={buttonClassName}
      id={buttonID}
      name={buttonName}
      aria-label={buttonAriaLabel}
      role={buttonRole}
      onClick={clickHandler}
      disabled={disabled}
      {...heapAttributes}
    >
      {children}
    </button>
  );
}
